import React, { useRef, useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import View from './UploadTemplate.view';
import useGrouping from 'Common/Utils/Hooks/useGrouping';
import { uploadTemplate } from './service';
import groupings from 'Common/Constants/Groupings';
import useQualificationYear from 'Common/Utils/Hooks/useQualificationYear';


const UploadTemplateContainer = () => {
    const initResult = { hasResult: false, result: null };

    const grouping = useGrouping();
    const inputRef = useRef(null);
    const [file, setFile] = useState(null);
    const qualYear = useQualificationYear().qualYear.toString();
    const [selectedYear, setYear] = useState(qualYear);
    const [uploadResult, setUploadResult] = useState(initResult);
    const [closeRequested, setCloseRequested] = useState(false);
    const [yearSelectorHide, hideYearSelector] = useState(false);
    const title = `Upload template for ${grouping}`;
    document.title = `Contract Management - ${title}`;    

    const updateYear = yearIn => {
        setYear(yearIn.toString());
    };
    useEffect(() => {
        if (grouping === groupings.Marker || grouping === groupings.Invigilator) {
            updateYear(qualYear);
            hideYearSelector(true);
        }
    }, []);
    
    const selectClick = () => {
        if (file) {
            setFile(null);
        }
        if (uploadResult.hasResult) {
            setUploadResult(initResult);
        }
        inputRef.current.click();
    };

    const fileSelect = event => {
        setFile(event.target.files[0]);
    };

    const uploadClick = async () => {
        const { name } = file;
        const result = await uploadTemplate(name, file, grouping, selectedYear);
        setUploadResult({ hasResult: true, result });
    };

    const onClose = () => {
        setCloseRequested(true);
    };

    if (closeRequested) {
		return <Redirect push to="/"></Redirect>;
    }

    return (
        <View
            title={title}
            handleSelectClick={selectClick}
            yearUpdated={updateYear}
            year={selectedYear}
            yearSelectorHide={yearSelectorHide}
            selectedYear={selectedYear}
            hideYearSelector={hideYearSelector}
            grouping={grouping}
            updateYear={updateYear} 
            inputRef={inputRef}
            handleFileSelect={fileSelect}
            filename={file?.name}
            handleUploadClick={uploadClick}
            uploadResult={uploadResult}
            onClose={onClose}            
        />
    );

};

export default UploadTemplateContainer;